import { render, staticRenderFns } from "./DetailsBank.vue?vue&type=template&id=e13be47a&scoped=true"
import script from "./DetailsBank.vue?vue&type=script&lang=js"
export * from "./DetailsBank.vue?vue&type=script&lang=js"
import style0 from "./DetailsBank.vue?vue&type=style&index=0&id=e13be47a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13be47a",
  null
  
)

export default component.exports